import { memo } from 'react';
import { View, StyleSheet, Text, Pressable, Image } from 'react-native';
import { THEME, COLOR, FONT, __WEB__ } from '../../../constants/styles';
import DateUtils from '../date_time_utils';
import DivWebOnly from '../div_web_only';

const DayButton = memo(function DayButton(props) {
  function handlePress() {
    props.onPress?.(props.i);
  }

  return (
    <DivWebOnly
      className={props.readOnly ? null : props.selected ? 'op-main-btn' : 'op-secondary-btn'}
    >
      <Pressable
        style={[styles.day, props.selected ? styles.selectedDay : null]}
        onPress={handlePress}
      >
        <Text style={[styles.dayText, props.selected ? styles.selectedDayText : null]}>
          {props.label}
        </Text>
        {!!props.selected ? (
          <Image
            style={styles.checkIcon}
            source={require('../../../../resources/checkmark.png')}
            resizeMode="contain"
          />
        ) : (
          <View style={styles.circle} />
        )}
      </Pressable>
    </DivWebOnly>
  );
});

export default memo(function DaySelect(props) {
  return (
    <View style={[styles.container, props.containerStyle]}>
      {props.headerLabel !== false && <Text style={styles.clinicalDaysHeader}>CLINICAL DAYS</Text>}
      <View style={[styles.daysContainer]}>
        <View style={THEME.basicRow}>
          {DateUtils.DAYS.map((label, i) => (
            <DayButton
              key={i + 1}
              label={label}
              i={i + 1}
              onPress={props.readOnly ? null : props.onPressDay}
              selected={!!props.selectedDays?.[i + 1]}
              readOnly={props.readOnly}
            />
          ))}
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    borderColor: 'rgb(241, 241, 241)',
    borderBottomWidth: 1,
  },
  clinicalDaysHeader: {
    backgroundColor: 'rgb(241, 241, 241)',
    ...FONT.regular,
    color: COLOR.text,
    textAlign: 'center',
    fontSize: 16,
    paddingVertical: 15,
    borderColor: 'rgb(228, 228, 228)',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    marginTop: 12,
  },
  daysContainer: {
    paddingVertical: 15,
    alignItems: 'center',
  },
  day: {
    width: 50,
    height: 50,
    borderRadius: 6,
    borderWidth: 1.5,
    borderColor: 'rgb(227, 227, 227)',
    marginHorizontal: __WEB__ ? 7 : 3,
    paddingTop: 8,
    alignItems: 'center',
  },
  selectedDay: {
    backgroundColor: COLOR.button,
    borderColor: COLOR.button,
  },
  dayText: {
    ...FONT.semibold,
    color: COLOR.textLight,
    fontSize: 10,
    textAlign: 'center',
  },
  selectedDayText: {
    color: 'white',
  },
  checkIcon: {
    width: 16,
    height: 16,
    tintColor: 'white',
    marginTop: 2,
  },
  circle: {
    width: 16,
    height: 16,
    borderRadius: 8,
    borderColor: COLOR.textLight,
    borderWidth: 1.5,
    marginTop: 3,
  },
});
